import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './VoteContainer.module.scss';
import { Stack, StackProps } from 'components/layout';

export const VoteContainer = (props: PropsWithChildren<StackProps>) => {
  const classes = classNames(styles.container, props.className);
  return (
    <Stack className={classes} spacing={4} {...props}>
      {props.children}
    </Stack>
  );
};
